const cardPalette = (tokens) => {
    return {
        border: {
            width: tokens.aliasesBorderWidthDefault,
            radius: tokens.aliasesBorderRadiusDefault
        },
        interactive: {
            background: {
                color: {
                    default: tokens.aliasesColorBgInteractiveContainerSubtleDefault,
                    hover: tokens.aliasesColorBgInteractiveContainerSubtleHover
                }
            },
            border: {
                color: {
                    default: tokens.aliasesColorBorderInteractiveContainerSubtleDefault,
                    hover: tokens.aliasesColorBorderInteractiveContainerSubtleHover
                }
            }
        }
    };
};
export default cardPalette;
//# sourceMappingURL=card.js.map